import Component from '@glimmer/component';

export default class StatusLightComponent extends Component {}
